export class VersionNumber {
    major: number;
    minor: number;

    constructor(versionString: string) {
        const [majorStr, minorStr] = versionString.split('.').map(str => parseInt(str));
        this.major = majorStr;
        this.minor = minorStr;
    }

    toString(): string {
        return `${this.major}.${this.minor}`;
    }

    isEqual(other: VersionNumber): boolean {
        return this.major === other.major && this.minor === other.minor;
    }

    isGreaterThan(other: VersionNumber): boolean {
        if (this.major > other.major) {
            return true;
        } else if (this.major === other.major) {
            return this.minor > other.minor;
        } else {
            return false;
        }
    }

    isLessThan(other: VersionNumber): boolean {
        return !this.isGreaterThan(other) && !this.isEqual(other);
    }

    static sort(versions: VersionNumber[]): VersionNumber[] {
        return versions.sort((a, b) => {
            if (a.major !== b.major) {
                return a.major - b.major;
            } else {
                return a.minor - b.minor;
            }
        });
    }
}